import Backbone from "backbone";


export default Backbone.Model.extend("MenuItem", {
    defaults: {
        id: 0,
        name: "Unknown",
        icon: "default",
        action: "default"
    }
});
